// utils
import get from "Utils/get";

/**
 * Listens for server errors. Will display an error notification.
 */
const ErrorResponseMiddleware =
	({ dispatch }) =>
	(next) =>
	(action) => {
		const { type } = action;

		if (/(FAIL)/.test(type)) {
			let message = "";
			const ignoreError = get(["request", "props", "__ignoreError"], action, false);

			try {
				message = action.response.error || action.response.data.errors[0];
			} catch (err) {
				message = "";
			}

			if (!ignoreError) {
				dispatch({
					type: "NOTIFICATION:ERROR",
					message: message || "Unknown Server Error",
					actionMessage: "Dismiss",
				});
			}
		}

		next(action);
	};

export default ErrorResponseMiddleware;
